export const PROPOSAL_TYPES = {
  DEFINITIVE: 'definitive',
  PROFORMA: 'proforma',
  ADDITIONAL: 'additional',
};

export const PROPOSAL_TYPE_OPTIONS = [
  { value: PROPOSAL_TYPES.DEFINITIVE, label: 'proposals.types.definitive' },
  { value: PROPOSAL_TYPES.PROFORMA, label: 'proposals.types.proforma' },
  { value: PROPOSAL_TYPES.ADDITIONAL, label: 'proposals.types.additional' },
];

export const WORK_ORDER_TYPES = {
  INSTALLATION: 'installation',
  MEASUREMENT: 'measurement',
  SERVICE: 'service',
};

export const WORK_ORDER_TYPE_OPTIONS = [
  { value: WORK_ORDER_TYPES.INSTALLATION, label: 'work_orders.types.installation' },
  { value: WORK_ORDER_TYPES.MEASUREMENT, label: 'work_orders.types.measurement' },
  { value: WORK_ORDER_TYPES.SERVICE, label: 'work_orders.types.service' },
];

export const PROPOSAL_WORKFLOW = {
  DIRECT: 'direct',
  MEASUREMENT: 'measurement',
};

/**
 * Stage picked when staff open the configurator, sent as `proposal_stage`.
 * Preliminary keeps the quote a proforma (showroom, not yet measured);
 * measured makes it definitive.
 */
export const PROPOSAL_STAGES = {
  PRELIMINARY: 'preliminary',
  MEASURED: 'measured',
};
